
const navigationImages = {
    containerLeft : document.getElementsByClassName('menu-container--left')[0],
    containerRight : document.getElementsByClassName('menu-container--right')[0],

    findGiven( imageID ){
        const elements = this.containerRight.querySelectorAll( '.header__images-wrapper--image' );
        let notFound = true;
        const preview = document.querySelector('.default-visible');
        if( preview ){
            preview.classList.remove('default-visible');
        }
        elements.forEach( (el, ind) =>{
            const elAttr = el.getAttribute('data-image');
            if( elAttr == imageID && notFound ){
                el.classList.add('default-visible');
                notFound = false;
            }
        });
    },

    setPrimaryActive(){
        const currentActive = this.containerLeft.querySelector('.current-menu-item');
        if( currentActive ){
            const imageID = currentActive.querySelector('.inner-trigger');
            if( imageID ){
                imageID.getAttribute('data-image');
                this.findGiven( imageID );
            }
        }
    },
    changeOnHover(){
        const links = this.containerLeft.querySelectorAll('.inner-trigger');
        [...links].forEach( (el, ind )=>{
            el.addEventListener('mouseover', e =>{
                const imageID = el.getAttribute('data-image');
                this.findGiven( imageID );
            });
            el.addEventListener('mouseleave', e =>{
                this.setPrimaryActive();
            });
        });
    }
}

export default navigationImages;